import { Routes } from '@angular/router';
import { ReportComponent } from './modules/report/views/report.component';
import { CaptureShellComponent } from './modules/capture-shell/capture-shell.component';
import { DashboardComponent } from './modules/dashboard/dashboard.component';
import { ExecutionResultComponent } from './modules/execution-result/views/execution-result.component';
import { TestSuiteComponent } from './modules/test-suite/views/test-suite.component';
import { ScenarioComponent } from './modules/scenario/views/scenario.component';
import { MainLayoutComponent } from './layout/main-layout.component';
import { TestRecorderComponent } from './modules/test-recorder/views/test-recorder/test-recorder.component';
import { TestRecorderListComponent } from './modules/test-recorder/views/test-recorder-list/test-recorder-list.component';
import { DataPreparationListComponent } from './modules/data-preparation/views/data-preparation-list.component';
import { ClientComponent } from './modules/client/views/client.component';
import { UserClientMappingComponent } from './modules/user-client-mapping/views/user-client-mapping/user-client-mapping.component';
import { ExecutionsComponent } from './modules/test-execution/executions/views/executions.components';
import { AuthGuard } from './auth/guards/auth.guard';
import { PackagesComponent } from './modules/packages/views/packages.component';
import { ClientPackageMappingComponent } from './modules/client-package-mapping/views/client-package-mapping.component';
import { AuthProfileComponent } from './modules/auth-profile/views/auth-profile.component';
import { ScreenMasterComponent } from './modules/screen-master/views/screen-master.component';
import { ReportGeneratorComponent } from './modules/report-generator/views/report-generator.component';
import { NotificationListComponent } from './modules/notification-list/views/notification-list.component';

export const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.routes')
  },
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      { path: 'dashboard', component: DashboardComponent },
      { path: 'test-suite', component: TestSuiteComponent },
      { path: 'packages', component: PackagesComponent },
      { path: 'scenario', component: ScenarioComponent },
      { path: 'execution-report', component: ReportComponent },
      { path: 'report-generator', component: ReportGeneratorComponent },
      { path: 'report-list', component: ReportGeneratorComponent, data: { tab: 'list' } },
      { path: 'report-generate', component: ReportGeneratorComponent, data: { tab: 'generate' } },
      { path: 'execution-results', component: ExecutionResultComponent },
      { path: 'notifications', component: NotificationListComponent },
      // { path: 'test-execution', component: TestExecutionListComponent },
      { path: 'test-execution', component: ExecutionsComponent },
      { path: 'admin/client', component: ClientComponent },
      { path: 'admin/user-client-mapping', component: UserClientMappingComponent },
      { path: 'admin/client-package-mapping', component: ClientPackageMappingComponent },
      { path: 'admin/auth-profile', component: AuthProfileComponent },
      { path: 'admin/screen-master', component: ScreenMasterComponent },
      { path: 'admin/skeletons', loadComponent: () => import('./modules/skeleton-management/views/skeleton-management.component').then(m => m.SkeletonManagementComponent) },
      { path: 'admin/skeletons-v2', loadComponent: () => import('./modules/skeleton-management/views/skeleton-management-v2.component').then(m => m.SkeletonManagementV2Component) },
      // User Client create/edit is now handled via dialog in mapping page
      // { path: 'test-execution/run-tests/:packageId/:scenarioId', component: RunTestsComponent },
      { path: 'feature/capture/:featureId', component: CaptureShellComponent },
      { path: 'scenario/capture/:functionalAreaId/:scenarioId', component: CaptureShellComponent },
      { path: 'test-studio/recorder-record', component: TestRecorderComponent },
      { path: 'test-studio/recorder-list', component: TestRecorderListComponent },
      { path: 'test-studio/data-preparation', loadComponent: () => import('./modules/data-preparation-v2/views/data-preparation-v2.component').then(m => m.DataPreparationV2Component) },
      { path: 'test-studio/data-preparation-legacy', component: DataPreparationListComponent },
      { path: 'test-studio/step-generation', loadComponent: () => import('./modules/step-generation/views/step-generation.component').then(m => m.StepGenerationComponent) },
      { path: 'test-studio/config-review', loadComponent: () => import('./modules/config-review/views/config-review.component').then(m => m.ConfigReviewComponent) },
      { path: 'test-studio/gap-analysis', loadComponent: () => import('./modules/gap-analysis/views/gap-analysis.component').then(m => m.GapAnalysisComponent) },
      { path: 'test-studio/data-preparation-v2', loadComponent: () => import('./modules/data-preparation-v2/views/data-preparation-v2.component').then(m => m.DataPreparationV2Component) },
      { path: 'test-studio/generation-report', loadComponent: () => import('./modules/generation-report/views/generation-report.component').then(m => m.GenerationReportComponent) },
      { path: 'configuration/scheduler', loadComponent: () => import('./modules/scheduler/views/scheduler.component').then(m => m.SchedulerComponent) }
    ]
  },
  { path: '**', redirectTo: '/auth/login' }
];